import {entityId} from '../../config/config';

export const getAuthUrl = ({
  tenantUrl,
  isDesktop,
  contentType,
  contentId,
  teamIds,
  parentGroupId,
}) => {
  // We check for app in the target rather than desktop because LFE links from the app have
  // exceptional behaviour while desktop behaves the same as non-BK LFE links
  const isApp = !isDesktop;
  // For the seamless dashboard link we need to pass 'null' in place of contentId
  // so RelayState in backend can handle correctly
  const cid = contentId || 'null';

  const allIds = [...teamIds];
  if (parentGroupId) {
    allIds.push(parentGroupId);
  }
  const teamIdsString = allIds.join(',');
  return `${tenantUrl}/auth_link?entity_id=${entityId}&target=${isApp},${contentType},${cid},${teamIdsString}`;
};
